import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-venue-room-table',
  standalone: false,
  templateUrl: './venue-room-table.component.html',
  styleUrl: './venue-room-table.component.scss',
})
export class VenueRoomTableComponent {
  @Input() roomList: any[] = [];
  @Output() edit = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() openModal = new EventEmitter<any>();

  editRoom(room: any) {
    this.edit.emit(room);
  }

  deleteRoom(roomId: number) {
    this.delete.emit(roomId);
  }

  openRoomModal(room: any) {
    this.openModal.emit(room);
  }
}
